import { render, staticRenderFns } from "./FeedingRecord.vue?vue&type=template&id=618957f4&scoped=true"
import script from "./FeedingRecord.vue?vue&type=script&lang=js"
export * from "./FeedingRecord.vue?vue&type=script&lang=js"
import style0 from "./FeedingRecord.vue?vue&type=style&index=0&id=618957f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618957f4",
  null
  
)

export default component.exports